import service from "./api.service";

class AzureMapsService {
  static readonly buscarCidade = ( query: string,  language: string): Promise<any> => {
    return service.get(`/azure-maps/cidade?query=${encodeURIComponent(query)}&language=${encodeURIComponent(language)}`);
  }
}

export default AzureMapsService;